/**
 * @license
 * Copyright Tyler Technologies, Inc. 
 * License: Apache-2.0
 */
import { COMPONENT_NAME_PREFIX } from '../constants';
const elementName = `${COMPONENT_NAME_PREFIX}open-icon`;
const observedAttributes = {
    OPEN: 'open',
    ORIENTATION: 'orientation',
    ROTATION: 'rotation'
};
const attributes = {
    ...observedAttributes
};
const defaults = {
    ORIENTATION: 'vertical',
    ROTATION: 'full'
};
export const OPEN_ICON_CONSTANTS = {
    elementName,
    observedAttributes,
    attributes,
    defaults
};
